import { apiClient } from '@/lib/apiClient';

export interface RegisterDeviceTokenReponse {
  success: boolean;
}

export interface RegisterDeviceTokenBody {
  tokenId: string;
}

export const registerDeviceToken = async ({ tokenId }: RegisterDeviceTokenBody): Promise<RegisterDeviceTokenReponse> => {
  const response = await apiClient.post<RegisterDeviceTokenReponse>(`/v1/notifications/devices`, { tokenId });
  return response.data;
};
